var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lp-adm-btn-container"},[_c('div',{staticClass:"lp-adm-btn",style:(_vm.btnStyle),on:{"click":function($event){return _vm.$emit('onClick')}}},[_vm._v(_vm._s(_vm.data))])])
}
var staticRenderFns = []

export { render, staticRenderFns }